module.exports = __webpack_public_path__ + "static/media/sustainability.852f31fe.png";